<router-outlet></router-outlet>

@if (!loader.loaded) {
  <app-main-preloader></app-main-preloader>
}
